import Vue from 'vue'
import Router from 'vue-router'
import University from '@/views/University'
import Landing from '@/views/Landing'
import KeywordSearch from '@/views/KeywordSearch'
// import CollegeSearch from '@/views/CollegeSearch'
import InterestSearch from '@/views/InterestSearch'
import Unit from '@/views/Unit'
import UnitPeriod from '@/views/UnitPeriod'
import UnitPlans from '@/views/UnitPlans'
import UnitInfo from '@/views/UnitInfo'
import PageContent from '@/views/PageContent'

Vue.use(Router)

export default new Router({
  // turn off history mode for now due to s3 deployment
  mode: 'history',
  routes: [
    {
      path: '',
      component: University,
      children: [
        {
          path: '',
          name: 'landing',
          component: Landing
        },
        {
          path: '',
          component: PageContent,
          children: [
            {
              path: 'name_search',
              name: 'nameSearch',
              component: KeywordSearch
            },
            // {
            //   path: 'college_search',
            //   name: 'collegeSearch',
            //   component: CollegeSearch
            // },
            {
              path: 'interest_search',
              name: 'interestSearch',
              component: InterestSearch
            },
            {
              path: 'units/:layout_id',
              component: Unit,
              children: [
                {
                  path: '',
                  name: 'unit-info',
                  component: UnitInfo
                },
                {
                  path: 'periods/:period_id',
                  component: UnitPeriod,
                  children: [
                    {
                      path: 'plans',
                      name: 'unit-plans',
                      component: UnitPlans
                    }
                  ]
                }
              ]
            }
            // {
            //   path: 'periods/:period_id/units/:layout_id',
            //   component: Unit,
            //   children: [
            //     {
            //       path: 'plans',
            //       name: 'unit-plans',
            //       component: UnitPlans
            //     }
            //   ]
            // }
          ]
        }
      ]
    }
  ],

  scrollBehavior(to, from, savedPosition) {
    return {x: 0, y: 0}
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js